import React, { useState } from 'react';

import { makeStyles } from '@styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import Button from '@components/Button';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@components/TextField';
import { standardAlert } from '@util/alert';

import logException from '@util/js-error';

import { useCreateLockdownBrowserAllowlistItem } from './ldb-allowlist-data-hooks';

const MAX_CHARS = 100;

const useStyles = makeStyles()(theme => ({
  button: {
    marginRight: theme.spacing(1)
  }
}));

const AddAllowlistItemPanel = ({ list, setIsAddingItem }) => {
  const { classes } = useStyles();

  const [newAllowlistItemProgram, setNewAllowlistItemProgram] = useState('');

  const { onCreateNewLockdownBrowserAllowlistItem, loading } =
    useCreateLockdownBrowserAllowlistItem();

  const onHandleCreate = () => {
    const name = (
      newAllowlistItemProgram.startsWith('CB-EXT:')
        ? newAllowlistItemProgram
        : newAllowlistItemProgram.toLowerCase()
    ).trim();

    if (list.map(({ program }) => program).includes(name)) {
      standardAlert(`The program ${name} already exists in the list.`);
    } else {
      (async () => {
        try {
          await onCreateNewLockdownBrowserAllowlistItem({
            variables: { input: { data: name } }
          });

          setIsAddingItem(false);
          setNewAllowlistItemProgram('');
        } catch (e) {
          logException(e);
        }
      })();
    }
  };

  const isNameTooLong = newAllowlistItemProgram.length > MAX_CHARS;

  return (
    <div>
      <TextField
        fullWidth
        autoFocus
        label="Program Name"
        disabled={loading}
        value={newAllowlistItemProgram}
        onChange={evt => setNewAllowlistItemProgram(evt.target.value)}
        onKeyDown={evt => {
          if (evt.key === 'Enter') {
            evt.preventDefault();
            onHandleCreate();
          }
        }}
        margin="normal"
        error={isNameTooLong}
        helperText={
          isNameTooLong
            ? `The program name cannot be more than ${MAX_CHARS} characters.`
            : ''
        }
        variant="outlined"
      />
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        disabled={!newAllowlistItemProgram.length || isNameTooLong}
        loading={loading}
        size="small"
        startIcon={loading ? null : <AddIcon />}
        onClick={onHandleCreate}
      >
        Add to Allowlist
      </Button>
      <Button
        className={classes.button}
        size="small"
        disabled={loading}
        startIcon={<ClearIcon />}
        onClick={() => setIsAddingItem(false)}
      >
        Cancel
      </Button>
    </div>
  );
};

export default AddAllowlistItemPanel;
